export enum TemplateCategories{
    AUTHENTICATION = "AUTHENTICATION",
    MARKETING = "MARKETING",
    UTILITY = "UTILITY"
}